import React, { useState, useEffect } from "react";

import { Paper, TableRow, TableCell } from "@material-ui/core";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";

import {
  DatatablesFooterServerSide,
  IconButtonDatatable,
  ModalDeleteConfirm,
  Title,
  Loading,
  InputCheckboxMaster,
  MasterButton,
} from "App/Component/ui";

import { STYLE_DEFAULT_MASTER } from "App/constants/theme";

import { useDatatablesServerSide, useDatatables } from "App/hooks";
import {
  deleteById,
  getByFilter,
  getReqListById,
  headCells,
  RenderStatusVerifikasiBadge,
  RESET_STATE_FORM_FILTER,
} from "./helpers";
import { AddIcon, PencilIcon, TrashIcon } from "App/Assets";
import {
  defaultDateDisplay,
  defaultDateInputDisplay,
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";

import { WMS_FA_HELPDESK } from "App/constants";
import {
  RenderStatusVerifikasiBadgePermintaan,
  STATUS_PENGERJAAN_DRAFT,
  STATUS_PENGERJAAN_PENGAJUAN,
  STATUS_PENGERJAAN_REVISI,
} from "../HelpDesk/helpers";
import FormFilter from "./FormFilter";
import { FreezeTable } from "components/organism";

export default function DaftarHelpDesk({
  changeTitle,
  changeParentData,
  changeMenu,
  handleClickMenu,
}) {
  const classes = STYLE_DEFAULT_MASTER();
  const [reqID, setReqID] = useState(null);
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);

  const handleClickUpdate = async (row) => {
    Promise.resolve()
      .then(() => {
        changeMenu(WMS_FA_HELPDESK);
      })
      .then(() => {
        changeParentData({
          id: row?.id,
          unit_id: row?.unit_id,
          unit: row?.unit,
          gudang_id: row?.gudang_id,
          gudang: row?.gudang,
          remark: row?.remark,
          remark_recive: row?.remark_recive,
          status_request: row?.status_request,
          user_request: row?.user_request,
          user_recive: row?.user_recive,
          type: "update",
          status: true,
          isOpenDraf:
            row?.status_request === STATUS_PENGERJAAN_DRAFT
              ? true
              : row?.status_request === STATUS_PENGERJAAN_REVISI
              ? true
              : false,
          isProcess:
            row?.status_request === STATUS_PENGERJAAN_DRAFT
              ? false
              : row?.status_request === STATUS_PENGERJAAN_REVISI
              ? false
              : true,
          taggal_request: defaultDateInputDisplay(row?.taggal_request),
          listreq: [],
        });
        changeTitle(WMS_FA_HELPDESK);
        handleClickMenu({
          code: WMS_FA_HELPDESK,
          name: "Help Desk",
        });
      });
  };

  const [rows, setRows] = useState([]);
  const [formFilter, setFormFilter] = useState(RESET_STATE_FORM_FILTER);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      await setNewData();
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const setNewData = async (
    pages = formFilter.pages,
    limit = formFilter.limit
  ) => {
    setLoading(true);

    const res = await getByFilter(formFilter, pages, limit);
    if (res.state) {
      setRows(res.data);
      setTotalData(res.meta.count);
      setLoading(false);
    } else {
      setRows([]);
      setLoading(false);
      defaultToastError(res.message);
    }
  };

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewData });

  const handleClickDelete = (row) => {
    setReqID(row?.id);
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  };

  async function deleteList() {
    const res = await deleteById(reqID);
    if (res.state) {
      defaultToastSuccess("Berhasil mengapus data !");
      setNewData();
    } else {
      defaultToastError(res.message);
    }
    setShowModalDeleteConfirm(false);
  }

  return (
    <>
      <div className={classes.root}>
        <Title title={"Daftar Request Help Desk"} />

        {showModalDeleteConfirm && (
          <ModalDeleteConfirm
            confirmHandle={() => deleteList()}
            setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
          />
        )}

        <Paper
          className={classes.paper}
          style={{
            padding: "1rem",
          }}>
          <FormFilter
            formFilter={formFilter}
            setFormFilter={setFormFilter}
            setNewData={setNewData}
          />
          <Loading show={loading} />
          <TableDaftarRequest
            rows={rows}
            classes={classes}
            handleClickDelete={handleClickDelete}
            handleClickUpdate={handleClickUpdate}
            loading={loading}
          />
          <DatatablesFooterServerSide
            totalData={totalData}
            pagination={pagination}
            handleChangeLimit={handleChangeLimit}
            onPrevious={onPrevious}
            onNext={onNext}
            currentPage={pagination.page}
            handleClickPageNumber={handleClickPageNumber}
          />
        </Paper>
      </div>
    </>
  );
}

export const TableDaftarRequest = ({
  rows,
  classes,
  handleClickUpdate,
  handleClickDelete,
  onlySelect = false,
  handleClickSelect,
  setShowModal,
  loading,
  rowsSelect,
  setRowsSelect,
}) => {
  const [rowsBarang, setRowsBarang] = useState([]);
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "id",
    orderByRow: ["id"],
  });

  const [activeRow, setActiveRow] = useState({
    index: null,
    id: null,
    unit_id: null,
    unit: null,
    gudang: null,
    gudang_id: null,
  });

  const setNewDataReq = async () => {
    if (!isNull(activeRow.id)) {
      setRowsBarang("Sedang Mengambil Data...");
      const res = await getReqListById(activeRow.id);
      if (res.state) {
        setRowsSelect([]);
        setRowsBarang(res.data);
      } else {
        setRowsBarang([]);
      }
    }
  };

  const handleClickSimpan = async () => {
    if (rowsSelect.length === 0) {
      defaultToastError("Harap pilih barang terlebih dahulu !");
    } else {
      handleClickSelect(activeRow);
      setShowModal(false);
    }
  };

  useEffect(() => {
    (async () => {
      await setNewDataReq();
    })();
  }, [activeRow.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const RenderAction = ({ row, index }) => {
    if (onlySelect) {
      if (row?.status_request >= STATUS_PENGERJAAN_PENGAJUAN) {
        return (
          <>
            <IconButtonDatatable
              color='secondary'
              onClick={() => {
                if (activeRow.index === index) {
                  setActiveRow({
                    id: null,
                    index: null,
                    unit_id: null,
                    unit: null,
                    gudang: null,
                    gudang_id: null,
                  });
                } else {
                  setActiveRow({
                    id: row.id,
                    unit_id: row?.unit_id,
                    unit: row?.unit,
                    index: index,
                    gudang: row?.gudang,
                    gudang_id: row?.gudang_id,
                  });
                }
              }}>
              <AddIcon />
            </IconButtonDatatable>
          </>
        );
      } else {
        return <></>;
      }
    } else {
      if (row?.status_request === STATUS_PENGERJAAN_DRAFT) {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "7px",
            }}>
            <IconButtonDatatable onClick={() => handleClickUpdate(row)}>
              <PencilIcon />
            </IconButtonDatatable>
            <IconButtonDatatable onClick={() => handleClickDelete(row)}>
              <TrashIcon />
            </IconButtonDatatable>
          </div>
        );
      } else {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "7px",
            }}>
            <IconButtonDatatable onClick={() => handleClickUpdate(row)}>
              <PencilIcon />
            </IconButtonDatatable>
          </div>
        );
      }
    }
  };

  const handleClickReset = () => {
    setRowsSelect([]);
  };

  return (
    <>
      <FreezeTable
        headCells={headCells}
        handleRequestSort={handleRequestSort}
        order={order}
        length={length}
        orderBy={orderBy}>
        {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
          return (
            <>
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                // style={{
                //   backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                // }}
              >
                <TableCell scope='row' padding='none' align='center'>
                  {index + 1}
                </TableCell>
                <TableCell scope='row' padding='none' align='center'>
                  <RenderAction row={row} index={index} />
                </TableCell>
                <TableCell align='left'>{row?.id}</TableCell>
                <TableCell align='left'>{row?.unit}</TableCell>
                <TableCell align='left'>{row?.gudang}</TableCell>
                <TableCell align='left'>{row?.user_request}</TableCell>
                <TableCell align='left'>
                  <RenderStatusVerifikasiBadge status={row?.status_request} />
                </TableCell>
                <TableCell align='left'>
                  {isNull(row?.remark) ? null : row?.remark}
                </TableCell>
                <TableCell align='left'>
                  {isNull(row?.taggal_recive)
                    ? "-"
                    : defaultDateDisplay(row?.taggal_recive)}
                </TableCell>
                <TableCell align='left'>
                  {isNull(row?.user_recive) ? "-" : row?.user_recive}
                </TableCell>
                <TableCell align='left'>
                  {isNull(row?.remark_recive) ? "-" : row?.remark_recive}
                </TableCell>
                <TableCell align='left'>
                  {defaultDateDisplay(row?.taggal_request)}
                </TableCell>
                <TableCell align='left'>
                  {defaultDateDisplay(row?.createdAt)}
                </TableCell>
                <TableCell align='left'>{row?.createdBy}</TableCell>
                <TableCell align='left'>
                  {defaultDateDisplay(row?.updatedAt)}
                </TableCell>
                <TableCell align='left'>{row?.updatedBy}</TableCell>
              </TableRow>
              {activeRow.index === index && (
                <>
                  <TableHeadDafarBarang index={index} />
                  <TableListBarang
                    rowsBarang={rowsBarang}
                    handleClickSelect={handleClickSelect}
                    rowsSelect={rowsSelect}
                    setRowsSelect={setRowsSelect}
                    row={row}
                  />
                </>
              )}
            </>
          );
        })}
        {rows.length === 0 && (
          <TableRow>
            <TableCell align='center' colSpan={headCells.length}>
              Tidak ada data
            </TableCell>
          </TableRow>
        )}
      </FreezeTable>
      {onlySelect && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
          }}>
          <MasterButton
            color='danger'
            type='button'
            name='RESET'
            onClick={handleClickReset}
            size='xl'
            style={{
              padding: "0.5rem 1rem",
              textAlign: "center",
            }}
          />
          <MasterButton
            color={loading ? "secondary" : "green"}
            type='button'
            name={loading ? "Loading.." : "SIMPAN"}
            disabled={loading}
            onClick={handleClickSimpan}
            size='xl'
            style={{
              padding: "0.5rem 1rem",
              textAlign: "center",
            }}
          />
        </div>
      )}
    </>
  );
};

const TableHeadDafarBarang = ({ index }) => {
  return (
    <>
      <TableRow
        hover
        tabIndex={-1}
        key={index}
        style={{
          backgroundColor: "#fff",
        }}>
        <TableCell component='th' align='left'></TableCell>
        <TableCell
          component='th'
          scope='row'
          padding='none'
          align='left'
          style={{
            padding: "1.5rem",
          }}>
          ACT
        </TableCell>

        <TableCell component='th' align='left'>
          ID
        </TableCell>

        <TableCell component='th' align='left' style={{ minWidth: "200px" }}>
          NAMA ASSET
        </TableCell>

        <TableCell component='th' align='left'>
          CODE ASSET
        </TableCell>

        <TableCell component='th' align='left'>
          CATATAN
        </TableCell>

        <TableCell component='th' align='left'>
          FILE
        </TableCell>

        <TableCell component='th' align='left'>
          STATUS
        </TableCell>

        <TableCell component='th' align='left'>
          CATATAN PEMERIKSAAN
        </TableCell>

        <TableCell component='th' align='left'>
          NO. FAKTUR
        </TableCell>

        <TableCell component='th' align='left'>
          USER VERIFIKASI
        </TableCell>

        <TableCell component='th' align='left'>
          TANGGAL VERIFIKASI
        </TableCell>
      </TableRow>
    </>
  );
};

const TableListBarang = ({
  rowsBarang,
  handleClickSelect,
  row,
  rowsSelect,
  setRowsSelect,
}) => {
  const handleClickSingleSelect = (row) => {
    const filter = rowsSelect.filter((item) => item.id === row.id);
    if (filter.length > 0) {
      const filterExcept = rowsSelect.filter((item) => item.id !== row.id);
      setRowsSelect(filterExcept);
    } else {
      setRowsSelect([...rowsSelect, row]);
    }
  };

  const checkAlready = (id) => {
    const filter = rowsSelect.filter((item) => item.id === id);
    return filter.length > 0 ? true : false;
  };
  return (
    <>
      {Array.isArray(rowsBarang) ? (
        rowsBarang.map((item, index) => {
          return (
            <>
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: "#f3f3f3",
                }}>
                <TableCell align='left'>{""}</TableCell>
                <TableCell>
                  <InputCheckboxMaster
                    name='status'
                    onClick={(e) => handleClickSingleSelect(item)}
                    checked={checkAlready(item.id)}
                    disabled={item.status_request === 0 ? false : true}
                    id='status'
                    label=''
                    style={{
                      marginTop: "-8px",
                      width: "31px",
                      height: "22px",
                    }}
                    endContent={true}
                  />
                </TableCell>
                <TableCell align='left'>{item?.id}</TableCell>
                <TableCell align='left'>{item?.nama_asset}</TableCell>
                <TableCell align='left'>{item?.code_asset}</TableCell>
                <TableCell align='left'>
                  {isNull(item?.remark) ? "-" : item?.remark}
                </TableCell>
                <TableCell align='left'>{item?.file_name}</TableCell>
                <TableCell align='left'>
                  <RenderStatusVerifikasiBadgePermintaan
                    status={item?.status_request}
                  />
                </TableCell>
                <TableCell align='left'>
                  {isNull(item?.remark_status) ? "-" : item?.remark_status}
                </TableCell>
                <TableCell align='left'>
                  {isNull(item?.no_faktur) ? "-" : item?.no_faktur}
                </TableCell>
                <TableCell align='left'>
                  {isNull(item?.user_approve) ? "-" : item?.user_approve}
                </TableCell>
                <TableCell align='left'>
                  {isNull(item?.taggal_approve)
                    ? "-"
                    : defaultDateDisplay(item?.taggal_approve)}
                </TableCell>
              </TableRow>
            </>
          );
        })
      ) : (
        <TableRow hover tabIndex={-1}>
          <TableCell component='th' align='center' colSpan='11'>
            {rowsBarang}
          </TableCell>
        </TableRow>
      )}
    </>
  );
};
